import React, { memo, useRef, useEffect } from 'react'
import * as d3 from 'd3'
import PropTypes from 'prop-types'
import { Typography } from '..'

const ProgressArc = ({
    className,
    percentage,
    svgWidth,
    svgHeight,
    arcWidth,
    color,
    showPercentage,
}) => {
    const arcRef = useRef(null)

    useEffect(() => {
        const arcOuterRadius = svgWidth / 2
        const arcInnerRadius = arcOuterRadius - arcWidth
        const ref = arcRef.current

        const svg = d3.select(ref).attr('width', svgWidth).attr('height', svgHeight)

        const group = svg
            .append('g')
            .attr('transform', `translate(${svgWidth / 2},${svgHeight / 2})`)

        const D3Arc = d3.arc().innerRadius(arcInnerRadius).outerRadius(arcOuterRadius).startAngle(0)

        /** Complete arc will have 6.28 radians */
        const _getProgressArc = progressVal => D3Arc({ endAngle: Math.PI * 2 * progressVal })

        /** The following path is a complete arc with gray color */
        group.append('path').attr('d', _getProgressArc(1)).attr('fill', 'rgb(213, 213, 215)')

        /** The following path is the colored arc */
        group
            .append('path')
            .attr('d', _getProgressArc(percentage / 100))
            .attr('fill', color)
            .transition()
            .delay(500)
            .duration(1500)
            .attrTween('d', arcTween)

        function arcTween() {
            var i = d3.interpolate(0, Math.PI * 2 * (percentage / 100))
            return t => D3Arc.endAngle(i(t))()
        }

        if (showPercentage === 'center') {
            group
                .append('text')
                .attr('x', -12)
                .attr('y', 10)
                .attr('class', 'progress-arc__percentage-text')
                .style('font-size', '8rem')
                .attr('fill', color)
                .text(percentage)
        }

        svg.exit().remove()
        return () => svg.select(ref).remove()
    }, [percentage, arcRef, svgWidth, svgHeight, color, arcWidth, showPercentage])

    return (
        <div className={`progress-arc ${className}`}>
            <svg ref={arcRef}></svg>
            {showPercentage === 'right' ? <Typography text={`${percentage}%`} size={'rg'} /> : null}
        </div>
    )
}

ProgressArc.propTypes = {
    className: PropTypes.string,
    percentage: PropTypes.number,
    svgWidth: PropTypes.number,
    svgHeight: PropTypes.number,
    arcWidth: PropTypes.number,
    color: PropTypes.string,
    showPercentage: PropTypes.bool,
}

export default memo(ProgressArc)
